import {tns} from "tiny-slider";

export function slider() {

    let sliderElement   = document.querySelector('.js-slider');


    if(sliderElement) {
        var slider = tns({
            container: '.js-slider',
            controls: true,
            controlsContainer: '.js-slider-controls',
            mouseDrag: true,
            nav: true,
            navContainer: '.js-slider-nav'
        })
    }

    return 'slider';
}
